import ImageCompressor from './image-compressor.esm';
import FileUtilities from './FileUtilities';
import truncate from 'lodash/truncate';
import last from 'lodash/last';

const compressImage = (file) => {
  const imageCompressor = new ImageCompressor();
  const imageCompressorOptions = {
    quality: 0.6,
    maxWidth: 1080,
  };

  const fileName = () => {
    if (file.name.length > 15) {
      return `${truncate(file.name, {length: 15, })}${last(file.name.split('.'))}`
    }

    return file.name;
  }

  const promise = new Promise((resolve, reject) => {
    if (!FileUtilities.isSizeSupported(file)) {
      const error = new Error(`${fileName()} exceeded 25MB size limit`);
      return reject(error);
    } else if (!FileUtilities.isTypeSupported(file)) {
      const error = new Error(`${fileName()}'s file type not supported`);
      return reject(error);
    } else if (FileUtilities.lessThan1KB(file)) {
      const error = new Error(`${fileName()} is blank`);
      return reject(error);
    }

    imageCompressor.compress(file, imageCompressorOptions)
    .then((blob) => { resolve(blob); })
    .catch((err) => { resolve(file); })
  })

  return promise;
}

export default compressImage;



// WEBPACK FOOTER //
// ./src/utils/compress-image.js